import axios from 'axios'
import { getToken } from './helpers/token'

const axiosInstance = axios.create({
  baseURL: '/api'
})

// Attach token
axiosInstance.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = token
  }

  return config;
});

export default axiosInstance
